<template>
  <div class="register">
         <div class="header">
            <div class="left">
                <!-- <div class="back" @click="onBack"></div> -->
                <!-- <div class="close" @click="close">关闭</div> -->
            </div>
            <div class="center ">
                <img src="../../assets/register/logo.png" alt="">
            </div>
            <!-- <div class="right" @click="refresh"></div> -->
        </div>
        <div class="main">
            <van-form @keyup.enter.native="sure">
                <ul>
                    <li>
                        <van-field  v-model.trim="formData.mobile" type="text" placeholder="请输入手机号码"/>
                    </li>
                    <li>
                        <van-field v-model.trim="formData.sms_code"  center clearable placeholder="请输入短信验证码">
                            <template #button>
                                <van-button  :disabled="disabled" @click="getcode" class="small" size="small" type="primary">{{btntxt}}</van-button>
                            </template>
                        </van-field>
                    </li>
                    <li>
                        <van-field type="password"  v-model.trim="formData.password"  placeholder="请设置密码"/>
                    </li>
                    <li>
                        <van-field v-model.trim="formData.re_password"  type="password" placeholder="请确认密码"/>
                    </li>
                    <li >
                        <van-field  v-model.trim="formData.invite_code" center clearable label="邀请码" placeholder="请输入邀请码" />
                    </li>
                </ul>
            </van-form >
            <div class="agree">
                <van-checkbox v-model="checked" checked-color="#666" icon-size="0.24rem">已阅读服务条款</van-checkbox>
            </div>
            <van-button  @click="sure" class="btn" type="primary" block>注册</van-button>
            <!-- <p class="title">下载APP</p> -->
            
           
        </div>
       
  </div>
</template>
<script>
import { Toast } from 'vant';
import { Dialog } from 'vant';
 import  {getQuery} from '@/utils/index';
export default {

  components: {
  
  },
  data() {
    return {
      checked:true,
      btntxt:'获取验证码',
      time:60,
      disabled:false,
      isShowInvite:'',
      formData:{

      }

    }
  },

  created() {
      try { 
          let obj=getQuery('invite_code')
          this.formData.invite_code=obj.invite_code
          
         ///||'236286'
      }catch(e){

      }
   
    

  },
  mounted() {

  },
  methods: {
    onSubmit(){
      console.log(11111)
    },
    onBack () {
      this.$router.go(-1)
    },
    // 刷新
    refresh () {
        location.reload()
    },
     timer() {
         if (this.time > 0) {
             this.disabled=true;
              this.time--;
              this.btntxt=this.time+"秒";
              setTimeout(this.timer, 1000);
         } else{
              this.time=60;
              this.btntxt="发送验证码";
              this.disabled=false;
         }
    },
    async getcode(){//获取验证码
         if(!(/^1[3456789]\d{9}$/.test(this.formData.mobile))) return  Toast('手机号格式不正确' )
         this.timer();
         let {data:res} = await this.$http.post(bizId+'/amoy/auth/sms-verifycode-web',{mobile:this.formData.mobile})
            if(res.code==0){
                this.isShowInvite=res.data.isShowInvite
                if(res.data.isShowInvite==0) 
                  Dialog.confirm({
                        title: '账号已注册',
                        message: '该账号已注册,是否跳入查看 \n 邀请链接页面',
                        confirmButtonText:'是',
                        cancelButtonText:'否',
                        confirmButtonColor:'#D8AD6C'
                        }).then(() => {
                        // on confirm
                        //  localStorage.setItem('img',res.data.invite_qrcode)
                        // this.$router.push('/registered')
                        this.$router.push({
                         path:'/registered',
                           query: {code: res.data.invite_qrcode}
                        })
                     }).catch(() => {
                        
                            // on cancel
                    });

         }
        
    },
    async sure(){//注册
         
         if(!(/^1[3456789]\d{9}$/.test(this.formData.mobile))) return  Toast('手机号格式不正确' )
          if(!this.formData.sms_code) return  Toast('短信验证码不能为空' )
         if(this.formData.re_password!=this.formData.password)Toast('两次输入密码不一致' )
         if(!this.formData.invite_code) return  Toast('请输入邀请码' )
         if(!this.checked) return  Toast('请先同意服务条款' )

          let {data:res}=await this.$http.post(bizId+'/amoy/auth/web-register',this.formData)
          if(res.code==0){
             
              console.log(res.data.invite_qrcode)
             //   localStorage.setItem('img',res.data.invite_qrcode)
             
             Toast('注册成功' )
             //    this.$router.push('/registered')
              //location.href=res.data.invite_img
              this.$router.push({
                  path:'/registered',
                  query: {code: res.data.invite_qrcode}
              })
          }
    }

    
  },
}
</script>
<style lang="less" scoped>
*{
    box-sizing: border-box;
}
.register{
    min-height: 100vh;
    background:linear-gradient(25deg,rgba(31,28,33,1) 0%,rgba(50,48,53,1) 100%);
    
  .header {
  position: relative;
  width: 100%;
  height: 0.88rem;
  color:#fff;
  line-height: 0.88rem;
  font-size: 0.34rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 0.01rem solid transparent;
    .left{
        display: flex;align-items: center; justify-content: center;
        position: absolute;
        bottom: 0;
        left: .3rem;
        height: 0.88rem;
        .back{
              height: .32rem;
                width: 0.18rem;
                background: url(../../assets/back1.png) no-repeat;
                background-size: cover;
        }
        .close{
           margin-left: 0.16rem;
            font-size:.3rem;
            font-weight:500;
            color:rgba(47,47,47,1);  
        }
    }
    .right{
        width: 0.32rem;
        height: 0.32rem;
        background: url('../../assets/icon-refresh.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0.3rem;
        top: 0.29rem;
    }
    .center{
        margin-top: 1.3rem;
       display: flex;
       justify-content: center;
       
       img {
           width: 1.3rem;
           height: 1.3rem;
       }
    }
 }  
}
.register{
    .main{
        margin:0 auto;
        width: 5rem;
        margin-top: 1.6rem;
        li{
            margin-top: 0.36rem;
            
            .van-field,
            input{
                width:5rem;
                height:0.88rem;
               
                background:rgba(64,63,67,1);
                border-radius:0.08rem;
                padding-left: 0.3rem;
            }
            input::placeholder{
               
                font-size:0.28rem;
               
                font-weight:500;
                color:rgba(167,168,167,1);
            }
            .small{
                width:1.62rem;
                height: 0.4rem;
                border:0.02rem solid rgba(255,255,255,1);
                border-radius:0.2rem;  
                background: transparent;
            }
        }
        .agree{
            margin: 0.46rem auto 0.4rem;
            
            .van-checkbox{
                justify-content: center;
            }
        }
        .title{
            padding-top: 0.36rem;
            text-align: center;
            font-size:0.32rem;
            font-weight:700;
            text-decoration:underline;
            color:rgba(216,173,108,1);
        }
        .btn{
            width:5rem;
            height:0.88rem;
            background:linear-gradient(-30deg,rgba(227,185,125,1) 0%,rgba(240,214,160,1) 100%);
            border-radius:0.08rem;
            font-size:0.34rem;
            font-weight:700;
            color:rgba(60,60,61,1);
            border: none;
        }
    }
}
</style>
<style lang="less" >
.register{
    .van-button--small{
        font-size: 0.24rem;
    }
    .agree{
        .van-checkbox__label{
                font-size:0.24rem;
                font-weight:500;
                color:#666;
              
            }
    }
    .main {
        .van-field__control{
                color:#fff;
           }
        .van-field__label{
            span{
                font-size:0.28rem;
                font-weight: 500;
                color:rgba(216,173,108,1);
            }
        }
    }
    .povers{
        .van-popup {

        }
    }
   
}
 .van-dialog{
      width: 5rem;
      .van-dialog__header{
          color: #D8AD6C;
      }
}
</style>




// WEBPACK FOOTER //
// src/pages/user/register.vue